/* AUTH */
export const GET_REPOCYCLESTEPS = 'GET_REPOCYCLESTEPS';
export const GET_REPOCYCLESTEPS_SUCCESS = 'GET_REPOCYCLESTEPS_SUCCESS';
export const GET_REPOCYCLESTEPS_FAILED = 'GET_REPOCYCLESTEPS_FAILED';
